<template>
  <div v-if="step < settings.length" class="global-mask">
    <div
      class="mask"
      :style="`top: ${current.top}; left: ${current.left}; width: ${current.w}; height: ${current.h}`"
    >
      <div
        :class="'guide-outer' + (current.center ? ' outer-center' : '')"
        :style="`${handlePosition(current)}`"
      >
        <div>
          <div class="guide-text">
            <div v-for="(item, index) in current.guides" :key="index">
              {{ item }}
            </div>
          </div>
          <div class="guide-btn mt-10" @click="handleBtn">
            {{ settings.length > step + 1 ? "下一步" : "我知道了" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },

  data() {
    return {
      step: 0,
      current: [],
      default: {
        top: "0px",
        left: "0px",
        w: "0px",
        h: "0px",
        position: "bottom",
        guides: [],
        btn: "next",
      },
    };
  },

  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler: function (val) {
        this.current =
          val[this.step] || JSON.parse(JSON.stringify(this.default));
      },
    },
  },

  methods: {
    handlePosition(current) {
      let { position, w, h, guideStyle } = current;
      let posVal = "";
      switch (position) {
        case "left":
          posVal = `left: -300px; width: 280px`;
          break;
        case "right":
          posVal = `left: calc(${w} + 20px)`;
          break;
        case "top":
          posVal = `bottom: calc(${h} + 20px)`;
          break;
        case "bottom":
          posVal = `top: calc(${h} + 20px)`;
          break;
      }
      if (guideStyle) posVal = `${posVal}; ${guideStyle}`
      return posVal;
    },

    handleBtn() {
      this.step += 1;
      this.current = this.settings[this.step];
      if (this.step > this.settings.length - 1) this.$emit('guideEnd')
    },
  },
};
</script>

<style lang="less" scoped>
.global-mask {
  position: fixed;
  //   下面两个定位字段不添加就是以组件被引用容器定位
    left: 0;
    height: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999999;
}

.mask {
  position: absolute;
  top: 100px;
  left: 100px;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  box-shadow: 0 0 200vw 200vw rgba(0, 0, 0, 0.5);
}

.guide-outer {
  position: absolute;
}

.outer-center {
  width: 100%;
  display: flex;
  justify-content: center;
}

.guide-text {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}

.guide-btn {
  position: absolute;
  padding: 0 10px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
</style>